var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.4971,
    r: 15,
    fill: "#FFEEEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2984 14.8408C19.6484 15.1408 20.6234 16.1346 20.6234 17.2971C20.6141 17.6532 20.5229 18.0025 20.3571 18.3178C20.1913 18.6332 19.9553 18.9062 19.6672 19.1158L20.2484 20.5596L18.3172 19.7533C18.0279 19.8176 17.7323 19.8491 17.4359 19.8471C15.8984 19.8471 14.6047 18.9658 14.3047 17.8033",
    stroke: "#FF6F61",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 18.8721L12.6375 17.6908C13.0438 17.7808 13.4589 17.8249 13.875 17.8221C16.3688 17.8221 18.375 16.2096 18.375 14.2221C18.375 12.2346 16.3688 10.6221 13.875 10.6221C11.3812 10.6221 9.375 12.2346 9.375 14.2221C9.375 15.2346 9.9 16.1533 10.7438 16.8096L9.75 18.8721Z",
    stroke: "#FF6F61",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIcon);
export default __webpack_public_path__ + "static/media/FeedbackIcon.5664bb32ab7ca041d3af1ce3022f7647.svg";
export { ForwardRef as ReactComponent };